<template>
    <div class="accordion-faq wow move-up">
        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-1 class="faq-title">Por que necesito una reunion con ustedes para tener mi formulario?</b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        En Datatonico nos preocupamos por brindarte una solución ajustada a tus necesidades específicas de captura de datos para tu estudio. En esta reunión podremos conocer tus necesidades, para que la información capturada sea significativa y te permita realizar análisis y obtener conclusiones adecuadas a los objetivos de tu investigación.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>

        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-2 class="faq-title">Cuanto tiempo tendré disponible mis formularios de captura de información?</b-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        Los formularios de captura de información pueden ser configurados para ser accedidos en todo momento o durante ciertos periodos. La información capturada podrás descargarla siempre, en el formato que más te acomode para poder analizarla (CSV, Excel, Texto, etc).
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>

        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-3 class="faq-title">Que medidas toman para poder resguardar la información capturada?</b-button>
            </b-card-header>
            <b-collapse id="accordion-3" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        Tomamos todas las medidas de seguridad disponibles para asegurar que tu información capturada sea almacenada en forma segura. El equipo de Datatonico no tiene acceso a tu información capturada, ya que se encuentra cifrada con algoritmos criptográficos utilizados en las compañías más prestigiosas.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>

        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-4 class="faq-title">Que herramientas tengo para aumentar la cantidad de datos capturados en mi población objetivo?</b-button>
            </b-card-header>
            <b-collapse id="accordion-4" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        Datatonico posee un sistema de notificación configurable, en donde podrás establecer la via de comunicación con tu población de estudio: mediante SMS o email.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>

        <b-card no-body>
            <b-card-header header-tag="header">
                <b-button block v-b-toggle.accordion-5 class="faq-title">En donde puedo ver como va progresando la captura de información de mi estudio?</b-button>
            </b-card-header>
            <b-collapse id="accordion-5" accordion="my-accordion">
                <b-card-body>
                    <b-card-text>
                        Si eres usuario de Datatonico tendrás acceso en forma permanente a un panel de administración de tu estudio, en donde podrás revisar el progreso de la información, así como información demográfica importante de tus usuarios.
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'Accordion',
    };
</script>